export default "__VITE_ASSET__DZO_Zb6p__"